import client from '../client';
import type { ApiResponse } from '../../types/api';

export interface IncomingTransfer {
  id: string;
  storeId: string;
  storeSlug: string;
  storeName: string;
  logo: string | null;
  fromEmail: string | null;
  retainedRole: string | null;
  createdAt: string;
}

export interface PendingTransfer {
  id: string;
  toEmail: string;
  retainedRole: string | null;
  createdAt: string;
}

export const ownershipApi = {
  // Transfers pending for the current user (across all stores).
  incoming: async (): Promise<IncomingTransfer[]> => {
    const res = await client.get<ApiResponse<{ transfers: IncomingTransfer[] }>>('/dashboard/ownership/incoming');
    return res.data.data?.transfers ?? [];
  },

  // The pending transfer initiated on a store (owner view), or null.
  getTransfer: async (storeId: string): Promise<PendingTransfer | null> => {
    const res = await client.get<ApiResponse<{ transfer: PendingTransfer | null }>>(
      `/dashboard/${storeId}/ownership/transfer`,
    );
    return res.data.data?.transfer ?? null;
  },

  // Owner initiates a transfer.
  initiate: async (
    storeId: string,
    data: { email: string; retainManager: boolean; retainTechnical: boolean },
  ): Promise<ApiResponse> => {
    const res = await client.post<ApiResponse>(`/dashboard/${storeId}/ownership/transfer`, data);
    return res.data;
  },

  // Owner cancels the pending transfer.
  cancel: async (storeId: string): Promise<void> => {
    await client.delete<ApiResponse>(`/dashboard/${storeId}/ownership/transfer`);
  },

  // New owner accepts.
  accept: async (storeId: string): Promise<{ storeSlug: string } | undefined> => {
    const res = await client.post<ApiResponse<{ storeSlug: string }>>(`/dashboard/${storeId}/ownership/accept`);
    return res.data.data;
  },

  // New owner declines.
  decline: async (storeId: string): Promise<void> => {
    await client.post<ApiResponse>(`/dashboard/${storeId}/ownership/decline`);
  },
};
